import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const OuterContainer = styled.section`
  position: sticky;
  top: calc(108.4px);
  z-index: 2;
  background-color: #F7F2EA;
  a {
    color: #2F7370;
  }
`;

export const GlobalNotificationContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const GlobalNotificationContent = styled.div`
  display: flex;
  gap: ${spacing(2)};
  padding: ${spacing(2)} 0;
  align-items: flex-start;
  flex-direction: column;

  ${mediaQuery.tabletLandscape`
    flex-direction: row;
    align-items: center;
  `}
`;
